<xemex-chart
  [datasets]="chartDatasets()"
  [labels]="chartLabels()"
  [note]="chartNote()"
  [badge]="chartBadge()"
  [loading]="telemetryStore.isLoadingDeviceTelemetry()"
  [options]="chartOptions()"
  [unit]="unit()"
  [filled]="filled()"
  [fillMode]="fillMode()"
></xemex-chart>
